// src/app/slices/damperSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { deleteAccessory } from './actions';
import { AccessoryState, IDamper, IDamperParams } from '../models';

const initialState: AccessoryState<IDamper, IDamperParams> = {
  accessories: {},
  params: null,
};

const damperSlice = createSlice({
  name: 'damper',
  initialState,
  reducers: {
    setDamper: (state, action: PayloadAction<IDamper>) => {
      if (!state.accessories[action.payload.section_id])
        state.accessories[action.payload.section_id] = {};
      state.accessories[action.payload.section_id][action.payload.id] =
        action.payload;
    },
    setDamperParams: (state, action: PayloadAction<IDamperParams>) => {
      state.params = action.payload;
    },
    deleteDamper: deleteAccessory,
  },
});

export const { setDamper, setDamperParams, deleteDamper } = damperSlice.actions;

export default damperSlice.reducer;
